import FormatDate from 'Assets/js/dateformatter';

function stringToArray(value) {
  let array = [];
  if (value.indexOf(',') !== -1) {
    array = value.split(',');
  } else if (value !== '') {
    array = [value];
  } else {
    array = [];
  }
  return array;
}

function arrayToString(value) {
  if (typeof value === 'object') {
    return value.join(',');
  }
  return value;
}

function objectToArray(data, obj) {
  const arr = [];
  Object.keys(obj).forEach((key) => {
    arr.push({
      value: obj[key],
      label: obj[key],
      children: (() => {
        if (data[key]) {
          return objectToArray(data, data[key]);
        }
        return [];
      })(data, key),
    });
  });
  return arr;
}

// 获取cookie
function getCookie(name) {
  const reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`);
  const arr = document.cookie.match(reg);
  if (arr) {
    return (arr[2]);
  }
  return null;
}

// 设置cookie,增加到vue实例方便全局调用
function setCookie(cName, value, expireDays) {
  const exDate = new Date();
  exDate.setDate(exDate.getDate() + expireDays);
  document.cookie = `${cName}=${escape(value)}${((expireDays === null) ? '' : `;expires=${exDate.toGMTString()}`)}`;
}

// 删除cookie
function delCookie(name) {
  const exp = new Date();
  exp.setTime(exp.getTime() - 1);
  const cookieValue = getCookie(name);
  if (cookieValue !== null) {
    document.cookie = `${name}=${cookieValue};expires=${exp.toGMTString()}`;
  }
}

// 从浏览器地址获取参数
function getParamFromUrl(name) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
  const r = window.location.search.substr(1).match(reg);
  if (r !== null) return decodeURIComponent(r[2].replace(/\+/g, '+'));
  return null;
}

// 从字符串获取参数
function getParam(name, string) {
  const reg = new RegExp(`(^|[&,?])${name}=([^&]*)(&|$)`, 'i');
  const r = decodeURIComponent(string).match(reg);
  if (r !== null) return decodeURIComponent(r[2].replace(/\+/g, '+'));
  return null;
}

export default {
  arrayToString,
  stringToArray,
  objectToArray,
  getCookie,
  setCookie,
  delCookie,
  getParam,
  FormatDate,
  getParamFromUrl,
};



// WEBPACK FOOTER //
// ./src/utils/index.js